// Base
import type { ChangeEvent } from "react";

// Types
import type { UseFormRegister, FieldValues } from "react-hook-form";

interface TextFieldProps {
  placeholder: string;
  error?: string;
  name: string;
  type?: string;
  value?: string | number;
  handleChange: (e: ChangeEvent) => void;
  autoComplete?: string;
  register: UseFormRegister<FieldValues>;
  contrast?: boolean;
}

const TextField = ({
  placeholder,
  error,
  name,
  type = "text",
  value,
  handleChange,
  autoComplete,
  register,
  contrast,
}: TextFieldProps) => {
  return (
    <div className="w-full">
      <div className="flex flex-col gap-1">
        <label
          className={`text-sm font-bold whitespace-nowrap ${
            contrast ? "text-cc-dark-gray" : "text-cc-gray"
          }`}
          htmlFor={name}
        >
          {placeholder}
        </label>
        <input
          className={`w-full rounded-md border bg-white p-4 text-sm ${
            contrast
              ? "border-cc-gray-5 placeholder-cc-gray-6"
              : "border-cc-gray-4 placeholder-dark-gray"
          }`}
          autoComplete={autoComplete}
          placeholder={placeholder}
          type={type}
          id={name}
          value={value}
          {...register(name)}
          onChange={handleChange}
        />
      </div>
      {error && <div className="mt-1 text-xs text-red-500">{error}</div>}
    </div>
  );
};

export default TextField;
